import styled from "styled-components";
import {
  PageContentHeader,
  PageContentHeaderActionsWrapper,
  PageContentWrapper,
} from "../../../styles/page";

export const MainWrapper = styled(PageContentWrapper)`
  padding: 4px 20px 38px;
  font-family: Pretendard;
  border-radius: 20px;
  background: #f0f3f8;
  height: auto;
  > .table-wrapper {
    display: flex;
    flex-direction: column;
    > .header {
      display: flex;
      flex-direction: row;
      width: 100%;
      > .item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        color: #121212;
        font-family: Pretendard;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      > .item.z {
        flex: 0.35;
      }

      > .item.a {
        flex: 1;
      }
      > .item.b {
        flex: 1;
      }
      > .item.c {
        flex: 0.6667;
      }
      > .item.d {
        flex: 0.6667;
      }
      > .item.e {
        flex: 2.1;
      }
      > .item.f {
        flex: 0.6667;
      }
      > .item.g {
        flex: 0.6667;
      }
      > .item.h {
        flex: 0.7323;
      }
      > .item.i {
        flex: 0.4646;
      }
      > .item.j {
        flex: 0.4646;
      }
    }

    > .list-wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;

      > .data-wrapper.selected {
        background: #7f25fb;

        > .item {
          color: #fff;
        }

        > .item.a {
          > .des {
            background-color: white;
            color: #7f25fb;
          }
          > .des.end {
            background-color: white;
          }
          > .des.starting {
            background-color: white;
          }
          > .des.stop {
            background-color: white;
          }
          > .des.lv {
            background-color: white;
          }
        }
      }
      > .data-wrapper {
        width: 100%;
        display: flex;
        flex-direction: row;
        border-radius: 15.04px;
        background: #fff;
        > .item {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 56px;
          color: var(--kakao-logo, #000);
          text-align: center;
          font-family: Pretendard;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        > .item.z {
          flex: 0.35;
          > img {
            cursor: pointer;
          }
        }
        > .item.a {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          > .des {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 103px;
            padding: 8px 0;
            border-radius: 10px;
            background-color: #383a54;
            color: #fff;
            text-align: center;
            font-family: Pretendard;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
          > .des.end {
            background: #bebebe;
          }
          > .des.starting {
            background: #fe5cee;
          }
          > .des.stop {
            background:
              linear-gradient(
                103deg,
                #6c36d6 -22.02%,
                #955fff 54.56%,
                #ccb2ff 102.58%
              ),
              #bebebe;
          }
          > .des.lv {
            background:
              linear-gradient(
                103deg,
                #6c36d6 -22.02%,
                #955fff 54.56%,
                #ccb2ff 102.58%
              ),
              #bebebe;
          }
        }
        > .item.b {
          flex: 1;
        }
        > .item.c {
          flex: 0.6667;
        }
        > .item.d {
          flex: 0.6667;
        }
        > .item.e {
          text-align: center;
          font-family: Pretendard;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          flex: 2.1;
        }
        > .item.f {
          flex: 0.6667;
        }
        > .item.g {
          flex: 0.6667;
        }
        > .item.h {
          cursor: pointer;
          flex: 0.7323;
        }
        > .item.i {
          flex: 0.4646;
          position: relative;
          > .drop-box {
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
            gap: 4px;
            position: absolute;
            top: 40px;
            display: inline-flex;
            padding: 12px;
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
            border-radius: 2.7px;
            background: #fff;
            z-index: 2;

            > .item {
              cursor: pointer;
              display: flex;
              width: 75px;
              height: 30px;
              justify-content: center;
              align-items: center;
              gap: 2px;
              border-radius: 15px;
              border: 1px solid var(--Black-100, #f0f0f0);
              font-family: Pretendard;
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
              color: var(--Black-500, #202020);
            }

            > .item:hover {
              background: var(--Purple-300, #6436e7);
              color: white;
            }
          }
        }
      }
    }
  }
`;

export const MainHeaderWrapper = styled(PageContentHeader)`
  background-color: #f0f3f8;
  margin-top: 30px;
  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
export const MainHeaderActionsWrapper = styled(PageContentHeaderActionsWrapper)`
  > .refresh-button {
    padding: 16px 55px;
    cursor: pointer;
    display: flex;
    border-radius: 15px;
    background-color: #bebebe;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .drop-box-wrapper {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    padding: 7px 12px;
    color: #121212;
    gap: 5px;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    background: #fff;
    position: relative;
    width: 114px;
    height: 50px;
    box-sizing: border-box;

    > img {
      width: 8px;
      height: 7px;
    }

    > .drop-box {
      box-sizing: border-box;
      position: absolute;
      top: 60px;
      display: flex;
      left: 0;
      width: 114px;
      padding: 12px;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);

      > .item {
        cursor: pointer;
        width: 90px;
        border-radius: 15px;
        border: 1px solid var(--Black-100, #f0f0f0);
        display: flex;
        height: 30px;
        justify-content: center;
        align-items: center;
        gap: 2px;
        align-self: stretch;
        color: var(--Black-500, #202020);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      > .item.active {
        background: var(--Purple-300, #6436e7);
        color: white;
      }
    }
  }

  > .add-button {
    padding: 16px 55px;
    cursor: pointer;
    display: flex;
    border-radius: 15px;
    background-color: #7f25fb;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const EditTournamentContentWrapper = styled.div`
  width: auto;
  height: 880px;
  padding: 43px 40px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 13.489px;
  display: flex;
  flex-direction: column;

  > .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    > span {
      color: #121212;
      font-family: Pretendard;
      font-size: 23.606px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    > img {
      width: 17px;
      height: 17px;
      cursor: pointer;
    }
  }

  .id {
    margin-left: 20px;
    color: #121212;
    font-family: Pretendard;
    font-size: 23.606px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const EditTournamentWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  top: 1%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 13.489px;
  display: flex;
  flex-direction: column;

  > .header {
    > span {
      color: #121212;
      font-family: Pretendard;
      font-size: 23.606px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    > img {
      width: 17px;
      height: 17px;
      cursor: pointer;
    }
    margin-top: 34.4px;
    margin-bottom: 18.3px;
    padding: 0 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  > .body {
  }
`;

export const EditTournamentHeaderSelectWrapper = styled.div`
  width: 148px;
  height: 50px;
  border-radius: 15px;
  gap: 5px;
  border: 1px solid #b7b7b7;
  background: #ffffff;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  position: relative;

  > img {
    width: 8px;
    height: 7px;
  }
`;

export const EditTournamentHeaderSelectItemWrapper = styled.div`
  position: absolute;
  border-radius: 8px;
  gap: 4px;
  padding: 12px;
  box-shadow: 0px 0px 8px 0px #0000001f;
  top: 60px;
  z-index: 1000;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: auto;

  > .no-data {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 11px;
  }
`;

export const EditTournamentHeaderSelectItem = styled.div<{ selected: boolean }>`
  width: auto;
  height: 30px;
  border-radius: 15px;
  padding: 8px 12px;
  box-sizing: border-box;
  line-height: 15px;
  text-align: center;
  gap: 2px;
  border: 1px solid var(--Black-100, #f0f0f0);
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;

  ${(p) =>
    p.selected
      ? `
    background: var(--Purple-300, #6436e7);
    color: #fff;

    svg path {
      stroke: #fff;
    }
    `
      : ""}

  svg path {
    stroke: var(--Black-400, #444);
  }
`;

export const EditTournamentHeader = styled.div`
  display: flex;
  gap: 20px;
  padding-top: 20px;

  > .button {
    width: 148px;
    height: 50px;
    border-radius: 15px;
    gap: 5px;
    border: 1px solid #b7b7b7;
    background: #ffffff;
    background: #6436e7;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 15px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
`;

export const EditTournamentBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  padding-top: 30px;

  display: flex;
  flex-direction: column;
  > .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 985px;
    height: 44px;
    padding: 0 17px;
    border-radius: 30.35px;
    background: #2f3332;
    box-sizing: border-box;
    gap: 6.7px;
    > .item {
      cursor: pointer;
      flex: 1;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--Black-200, #b7b7b7);
      text-align: center;
      font-family: Pretendard;
      font-size: 13.489px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    > .item.active {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 13.489px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      border-radius: 30.35px;
      background: var(--Purple-300, #6436e7);
    }

    > .item.red.active {
      background: #ff0000;
    }
  }
`;

export const EditTournamentBottom = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 40px;
  bottom: 16px;
  justify-content: center;

  > .button {
    cursor: pointer;
    width: 422.205px;
    height: 59.352px;
    border-radius: 30.35px;
    background: #969696;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 20.233px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .button.purple {
    background: var(--Purple-300, #6436e7);
  }
`;
